export default () => {
  function initModal(el) {
    const dialog = el.querySelector('.membership-type__modal');
    const opener = el.querySelector('[data-membership-modal-target="open"]');
    if (!dialog || !opener || typeof dialog.showModal !== 'function') return;

    opener.addEventListener('click', () => dialog.showModal());

    el.querySelectorAll('[data-membership-modal-target="close"]').forEach(button =>
      button.addEventListener('click', () => dialog.close())
    );

    dialog.addEventListener('click', e => {
      if (e.target === dialog) dialog.close();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-controller="membership-modal"]').forEach(initModal);
  }

  document.addEventListener('DOMContentLoaded', initAll);
};
